<div class="modal-content">
    <div class="modal-header text-center">

    </div>
    <div class="modal-body pb-5">
        <img src="assets/img/user-white.svg">
        <h3 class="mt-2">{{ejecutivo}}</h3>
        <h6>Cargo Usuario</h6>
        <hr class="w-75 mx-auto">
        <h2>ATENCIÓN PAUSADA</h2>
    </div>
    <div class="modal-footer">
        <div class="row">
            <div class="col-12">
                <h5>¿Necesitas reanudar tu atención?</h5>
            </div>
            <div class="col-12 d-flex flex-column align-items-center">
                <button type="button" class="play" (click)="finPausa('continuar');">
                    <img src="./assets/img/play.svg" height="110px">
                </button>
             
                <button class="btn mt-2 btn-excepcion btn-excepcion-modal text-center" type="button" (click)="finPausa('continuarUrgencia');">
                    <img class="mr-3" src="./assets/img/e-fila.svg"> EXCEPCIÓN FILA
                  </button>
            </div>
            <div class="col-12 mt-4"> <button class="close-detail" (click)="finPausa('cerrar');">CERRAR SESIÓN</button></div>
        </div>
    </div>
</div>
